import React from 'react'
import styles from './index.module.scss'
import Textfield from '@bt-react/components/Textfield'
import Button from '@bt-react/components/Button'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { IconType } from '@bt-react/components/Icon'
import browser from '@bt-react/libs/browser'
import { ChromeButton, EdgeButton } from '../../components/BrowserButton'

const assetsPath = process.env.NODE_ENV === 'production' ? '/presenting' : ''

const errorMessages = {
  'ResourceNotFound': 'PIN is invalid',
  'Invalid': 'PIN must be an 8 digit number'
}

export function Index() {

  const [pin, setPin] = useState(null)
  const [error, setError] = useState(null)
  const [isBrowserNotSupported, setIsBrowserNotSupported] = useState(false)

  useEffect(() => {
    axios.get(`/service/user/session/user`, {
      withCredentials: true
    }).then((response) => {

      const user = response?.data?.externalIdV2 ?? ''
      const preAuth = response?.data?.preAuth

      if (user === '' || preAuth === 'true') window.location.href = '/login/?redirect=%2Fpresenting'

    }).catch(() => {
      window.location.href = '/login/?redirect=%2Fpresenting'
    })
  }, [])


  const onPinChange = (id, value) => {
    setError(null)
    if (value && Number.isInteger(Number(value))) {
      setPin(value)
    } else {
      setError(errorMessages['Invalid'])
    }

  }


  const onSubmit = async () => {

    if (!pin) {
      return setError(errorMessages['Invalid'])
    }

    if (pin.length !== 8) {
      return setError(errorMessages['Invalid'])
    }

    if (pin && !error) {

      try {
        const response = await axios.get(`/service/communication/v1/present/pin/${pin}`)
        if (response && response.data && response.data.id && response.data.provider.name === 'webcamtalk') {
          if (!browser.isChromiumBased()) {
            return setIsBrowserNotSupported(true)
          }
          
          if (response.data.status === 'processing' || response.data.status === 'recorded') {
            setError(errorMessages['ResourceNotFound'])
          }
          if (response.data.status === 'upcoming' || response.data.status === 'live') {
            window.location.href = `/talks/present/${response.data.channel.id}-${response.data.id}`
          }
        }
      } catch (e) {
        setError(errorMessages[e.response.data.code] ? errorMessages[e.response.data.code] : e.response.data.message)
      }
    }
  }

  const getDefaultForm = () => {
    return <>
      <h1 data-bdd='headline'>Welcome!</h1>
      <p data-bdd='main-text' className={styles['intro']}>Please enter the PIN you have been provided to proceed:</p>
      <div data-bdd='form-inner' className={styles['form-fields']}>
        <Textfield dataBdd='pin-field' placeholder='Enter PIN here' error={error} onChange={onPinChange} onKeyPress={(e) => { e.which === 13 && onSubmit()}}/>
        <Button dataBdd='enter-button' color={IconType.colour.primary} onClick={onSubmit}>Enter</Button>
      </div>
      <div data-bdd='error' className={styles['form-error']}>{error || ''}</div>
      <p data-bdd='contact'><b>Don't have a PIN?</b> Contact the event organizer to obtain it.</p>
    </>
  }

  const getNotSupportedBrowserView = () => {
    return <>
      <h1 data-bdd='headline'>Unsupported browser!</h1>
      <p data-bdd='main-text' className={styles['intro']}>Download Chrome or Edge browser to present.</p>
      <div data-bdd='browser-buttons' className={styles['browser-buttons']}>
        <ChromeButton /><EdgeButton />
      </div>

    </>
  }

  const getMainContent = () => {
    if (isBrowserNotSupported) {
      return getNotSupportedBrowserView()
    }
    return getDefaultForm()
  }

  return (
    <div className={styles['container']}>
      <div>
        <a data-bdd='logo' className={styles['logo']} rel='nofollow' href='/'><img alt='BrightTALK' src={`${assetsPath}/images/logo.svg`} width={160}/></a>
        <div className={styles['main-content']}>
          {getMainContent()}
        </div>
        <p data-bdd='help'><b>Experiencing difficulties?</b> Visit our <a data-bdd='help-link' rel='nofollow' href='https://techtarget.service-now.com/csm?id=kb_category&kb_id=59c5c978fbb09a10874bfb624eefdca0&kb_category=3e984df8fbb09a10874bfb624eefdc10'>Support portal</a>.</p>
      </div>
      <div data-bdd='image' className={styles['image']}><img alt='' src={`${assetsPath}/images/asset-desktop-001.png`} /></div>
    </div>
  );
}

export default Index;
